import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../theme';

/**
 * Custom hook that defines the styles for the profile page component.
 */
const useProfilePageStyles = makeStyles()(() => ({
  profileContainer: {
    backgroundColor: colors.white,
    borderRadius: theme.borderRadius.s,
    boxShadow: theme.containerShadow,
    padding: theme.padding.l,
    margin: theme.margin.m,
    overflow: 'wrap',
  },
  userProfileInfo: {
    'display': 'flex',
    '@media (max-width: 950px)': {
      flexDirection: 'column',
    },
    'alignItems': 'center',
    'justifyContent': 'space-around',
    'width': '100%',
    'margin': `0 ${theme.margin.s} ${theme.margin.l} ${theme.margin.s}`,
  },
  achievementAwardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'bottom',
    justifyContent: 'flex-start',
    gap: theme.gap.m,
    padding: `0 ${theme.padding.m}`,
    flexWrap: 'wrap',
  },
  userInfoSettings: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.gap.m,
  },
  followUnfollowButton: {
    width: '150px',
  },
  followLoading: {
    pointerEvents: 'none',
  },
  emptySection: {
    paddingLeft: theme.padding.s,
    fontSize: theme.fontSize.default,
    paddingBottom: theme.padding.m,
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: theme.gap.xs,
  },
  userActivity: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.gap.m,
    flexWrap: 'wrap',
  },
  userActivitySection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '29%',
    padding: `0 ${theme.padding.m}`,
    marginBottom: theme.margin.m,
  },
  emptyQACSection: {
    fontSize: theme.fontSize.default,
    paddingBottom: theme.padding.m,
  },
  qAC: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'bottom',
    justifyContent: 'flex-start',
    gap: theme.gap.m,
    padding: `${theme.padding.m} ${theme.padding.s} 0 ${theme.padding.s}`,
    flexWrap: 'wrap',
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'row',
  },
  gameParrotIcon: {
    height: '70px',
    width: 'auto',
    cursor: 'pointer',
  },
}));

export default useProfilePageStyles;
